export default __webpack_public_path__ + "static/media/logoutLogo.7646f352.svg";